// extracted by mini-css-extract-plugin
module.exports = {"outerLabel":"style_outerLabel__4sPSk","chartArea":"style_chartArea__2SzYP","chartScale":"style_chartScale__1kavv"};